import Store from '@/core/services/store'
import i18n from "@/core/plugins/vue-i18n";

function Toast(type, message, timeout=2000){
    Store.dispatch('toast/message' , message)
    Store.dispatch('toast/type' , type)
    Store.dispatch('toast/timeout' , timeout)
    Store.dispatch('toast/show' , true)
}


function Error(message, timeout=2000){
    if (!message) message = i18n.t("ERRORS.Error")
    Store.dispatch('toast/message' , message)
    Store.dispatch('toast/type' , 'error')
    Store.dispatch('toast/timeout' , timeout)
    Store.dispatch('toast/show' , true)
}

function Success( message, timeout=2000){
    Store.dispatch('toast/message' , message)
    Store.dispatch('toast/type' , 'success')
    Store.dispatch('toast/timeout' , timeout)
    Store.dispatch('toast/show' , true)
}

const exp = {
    Toast,
    Error,
    Success
}

export default exp

export const install = {
    install(Vue){
        Vue.prototype.$toast = exp
    }
}